import { Drawer, DrawerProps, useMediaQuery, useTheme } from "@mui/material";

// Keep the desktop rail, but give the content the full viewport on touch layouts.
const ResponsiveSidebar = ({
  open,
  onClose,
  sx = [],
  ...props
}: DrawerProps) => {
  const theme = useTheme();
  const overlay = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Drawer
      {...props}
      variant={overlay ? "temporary" : "permanent"}
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={[
        ...(Array.isArray(sx) ? sx : [sx]),
        ...(overlay
          ? [
              {
                width: 0,
                "& .MuiDrawer-paper": {
                  width: 280,
                  maxWidth: "calc(100vw - 32px)",
                  top: 64,
                  height: "calc(100% - 64px)",
                  overflowY: "auto",
                },
              },
            ]
          : []),
      ]}
    />
  );
};

export default ResponsiveSidebar;
